document.addEventListener("DOMContentLoaded", () => {
  const STORAGE_KEY = "themex-recently-viewed";
  const CLIENT_ID_STORAGE_KEY = "themex-client-id";
  const LIST_ID = "recently_viewed_mweb";
  const LIST_NAME = "recently_viewed";

  const section = document.getElementById("pdp-recently-viewed-section");
  const list = document.getElementById("pdp-recently-viewed-list"); 
  const loader = document.getElementById("pdp-recently-viewed-loader");
  const dots = document.getElementById("pdp-recently-viewed-dots");

  if (!section || !list) return;

  const MAX_ITEMS = parseInt(section.dataset.maxProducts, 10) || 8;

  const getClientId = () => {
    const gaCookie = document.cookie.match(/(?:^|;\s*)_ga=([^;]+)/);
    if (gaCookie) {
      const parts = decodeURIComponent(gaCookie[1]).split(".");
      if (parts.length >= 4) return `${parts[2]}.${parts[3]}`;
    }

    let clientId = localStorage.getItem(CLIENT_ID_STORAGE_KEY);
    if (!clientId) {
      clientId = crypto.randomUUID
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      localStorage.setItem(CLIENT_ID_STORAGE_KEY, clientId);
    }
    return clientId;
  };

  const getExpVariantString = () => window.dnkExperimentVariant || section.dataset.expVariant || null;

  const buildItemPayload = (card) => ({
    item_id: card.dataset.itemId,
    item_name: card.dataset.itemName,
    index: card.dataset.index,
    item_brand: card.dataset.itemBrand || "NA",
    item_category: card.dataset.itemCategory || "NA",
    item_category2: "NA",
    item_category3: "NA",
    item_category4: "NA",
    item_category5: "NA",
    item_list_id: LIST_ID,
    item_list_name: LIST_NAME,
    item_variant: card.dataset.itemVariant || null,
    price: card.dataset.itemPrice,
  });

  const pushEcommerceEvent = (eventName, items) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: eventName,
      client_id: getClientId(),
      exp_variant_string: getExpVariantString(),
      item_list_id: LIST_ID,
      item_list_name: LIST_NAME,
      ecommerce: { items },
    });
  };

  const pushAddToCart = (card, quantity) => {
    const price = parseFloat(card.dataset.itemPrice) || 0;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: "add_to_cart",
      client_id: getClientId(),
      exp_variant_string: getExpVariantString(),
      item_list_id: LIST_ID,
      item_list_name: LIST_NAME,
      ecommerce: {
        currency: section.dataset.currency || "INR",
        value: (price * quantity).toFixed(2),
        items: [{ ...buildItemPayload(card), discount: card.dataset.itemDiscount || "0", quantity }],
      },
    });
  };

  const initImpressionTracking = () => {
    const trackedIds = new Set();

    const cardObserver = new IntersectionObserver(
      (entries) => {
        const newlyVisible = [];

        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const card = entry.target;
          const itemId = card.dataset.itemId;
          if (!itemId || trackedIds.has(itemId)) return;

          trackedIds.add(itemId);
          newlyVisible.push(buildItemPayload(card));
          cardObserver.unobserve(card);
        });

        if (newlyVisible.length) pushEcommerceEvent("view_item_list", newlyVisible);
      },
      { root: null, threshold: 0.5 },
    );

    const sectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          [...list.children].forEach((card) => cardObserver.observe(card));
          sectionObserver.unobserve(section);
        });
      },
      { root: null, threshold: 1.0 },
    );

    sectionObserver.observe(section);
  };

  const initInteractionTracking = () => {
    list.addEventListener("click", (event) => {
      const link = event.target.closest("a");
      const card = link?.closest("[data-recently-viewed-card]");
      if (!card) return;

      pushEcommerceEvent("select_item", [buildItemPayload(card)]);
    });

    const pendingAddToCart = new Map();

    list.addEventListener(
      "submit",
      (event) => {
        const form = event.target.closest("[data-product-form]");
        const card = form?.closest("[data-recently-viewed-card]");
        if (!card) return;

        const quantity = parseInt(form.querySelector('input[name="quantity"]')?.value, 10) || 1;
        pendingAddToCart.set(card.dataset.productId, { card, quantity });
      },
      true,
    );

    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (data) => {
        const pending = pendingAddToCart.get(data.productId);
        if (!pending) return;

        pendingAddToCart.delete(data.productId);
        pushAddToCart(pending.card, pending.quantity);
      });
    }
  };

  const getRecentlyViewed = () => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  };

  const saveRecentlyViewedProduct = (handle) => {
    if (!handle) return;
    const handles = getRecentlyViewed().filter((h) => h !== handle);
    handles.unshift(handle);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(handles.slice(0, MAX_ITEMS)));
  };

  const getCurrentProductHandle = () => {
    const match = window.location.pathname.match(/\/products\/([^/?]+)/);
    return match ? match[1] : null;
  };

  const showLoader = () => {
    loader?.classList.remove("hidden");
    loader?.classList.add("flex");
    list.classList.add("hidden");
  };

  const hideLoader = () => {
    loader?.classList.add("hidden");
    loader?.classList.remove("flex");
    list.classList.remove("hidden");
  };

  const setActiveDot = (index) => {
    if (!dots) return;
    [...dots.children].forEach((dot, i) => {
      dot.classList.toggle("is-active", i === index);
    });
  };

  const buildDots = (count) => {
    if (!dots) return;
    dots.innerHTML = "";

    if (count < 2) {
      dots.classList.add("hidden");
      dots.classList.remove("flex");
      return;
    }

    for (let i = 0; i < count; i += 1) {
      const dot = document.createElement("button");
      dot.type = "button";
      dot.className =
        "pdp-recently-viewed__dot block w-[10px] h-[10px] [&.is-active]:w-[15px] p-0 bg-[#c8c8c8] rounded-full cursor-pointer transition-colors duration-200 [&.is-active]:bg-[#ff40b1] md:w-[15px] md:h-[15px] md:bg-white md:border md:border-solid md:border-black md:[&.is-active]:bg-foreground";
      dot.setAttribute("aria-label", `Go to recently viewed product ${i + 1}`);
      dot.addEventListener("click", () => {
        // The tapped dot stays active while the list scrolls to it (the last cards can't reach the
        // left edge, so the scroll position alone would point at another dot).
        tappedDot = i;
        setActiveDot(i);
        list.scrollTo({ left: list.children[i].offsetLeft, behavior: "smooth" });
      });
      dots.appendChild(dot);
    }

    dots.classList.remove("hidden");
    dots.classList.add("flex");
    setActiveDot(0);
  };

  let scrollFrame = null;
  let tappedDot = null;
  // The shopper swiping again hands the dots back to the scroll position.
  const releaseTappedDot = () => {
    tappedDot = null;
  };
  ["pointerdown", "touchstart", "wheel", "keydown"].forEach((type) =>
    list.addEventListener(type, releaseTappedDot, { passive: true }),
  );

  list.addEventListener(
    "scroll",
    () => {
      if (!dots || dots.classList.contains("hidden") || scrollFrame) return;
      if (tappedDot !== null) return;
      scrollFrame = requestAnimationFrame(() => {
        scrollFrame = null;
        const card = list.children[0];
        if (!card) return;
        const cardWidth = card.getBoundingClientRect().width;
        const gap = parseFloat(getComputedStyle(list).columnGap) || 0;
        const lastIndex = list.children.length - 1;
        // The last cards can't scroll to the left edge (several fit on screen), so at the end of
        // the scroll the last dot is active.
        const atEnd = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
        const index = atEnd ? lastIndex : Math.round(list.scrollLeft / (cardWidth + gap));
        setActiveDot(Math.min(Math.max(index, 0), lastIndex));
      });
    },
    { passive: true },
  );

  const hideSection = () => {
    section.classList.add("hidden");
    buildDots(0);
  };

  const renderRecentlyViewedProducts = async (excludeHandle) => {
    const handles = getRecentlyViewed().filter((h) => h !== excludeHandle);
    if (handles.length === 0) return hideSection();

    section.classList.remove("hidden");
    showLoader();

    const handlesParam = handles.map(encodeURIComponent).join(",");
    const root = window.Shopify?.routes?.root || "/";

    try {
      const response = await fetch(
        `${root}?sections=recently-viewed-products&handles=${handlesParam}`,
      );
      if (!response.ok) throw new Error("Failed to fetch recently viewed products");

      const { "recently-viewed-products": html } = await response.json();
      const content = html
        ? new DOMParser().parseFromString(html, "text/html").getElementById("recently-viewed-products-content")
        : null;

      if (content?.children.length) {
        list.innerHTML = content.innerHTML;
        buildDots(content.children.length);
        hideLoader();
        initImpressionTracking();
        initInteractionTracking();
      } else {
        hideSection();
        hideLoader();
      }
    } catch {
      hideLoader();
      hideSection();
    }
  };

  const currentHandle = getCurrentProductHandle();

  renderRecentlyViewedProducts(currentHandle);

  if (currentHandle) {
    saveRecentlyViewedProduct(currentHandle);
  }
});
